import React from "react";
import { Cpu } from "lucide-react";
import { NexusScenes } from "./NexusScenes";
import { WallTicker } from "../NexusWall";
import { LiveClock } from "../LiveClock";
import { TvTickerBar } from "./TvTickerBar";
import { TvEyeAlert } from "./TvEyeAlert";
import { FloorPipeline } from "./FloorPipeline";

export const B_SCENES = ["team", "floor", "floor-day", "news", "business", "newsroom", "globe", "intel", "madmoney", "channels", "record", "brokers", "whales", "earnings", "ira"];

export default function TvScreenB({ session, floorOnly = false }) {
  return (
    <div className="h-screen w-screen overflow-hidden bg-[#030712] text-[#F3F4F6] nx-display nx-scanlines grid grid-rows-[72px_minmax(0,1fr)_48px]" data-testid={floorOnly ? "tv-floor" : "tv-b"}>
      <header className="grid grid-cols-[auto_1fr_auto] items-center gap-6 px-8 border-b border-cyan-300/10" data-testid="tv-b-header">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg nx-glass flex items-center justify-center text-[#00F0FF]"><Cpu className="w-5 h-5" /></div>
          <div><p className="nx-orbitron font-black tracking-widest text-lg leading-none">A V NEXUS</p><p className="nx-mono text-[10px] tracking-[0.3em] text-cyan-300/50">{floorOnly ? "TV · TRADING FLOOR" : "TV B · INTEL"}</p></div>
        </div>
        <span />
        <div data-testid="tv-live-clock"><LiveClock /></div>
      </header>
      <main className="min-h-0 px-8 py-4">
        {floorOnly ? <FloorPipeline /> : <NexusScenes userId={session.user_id} only={B_SCENES} screen="b" />}
      </main>
      <TvTickerBar><WallTicker userId={session.user_id} /></TvTickerBar>
      <TvEyeAlert userId={session.user_id} />
    </div>
  );
}
